class ProductYotpoReviews extends HTMLElement {
  constructor() {
    super()
    this.init()
  }

  init() {
    const observer = new MutationObserver(() => {
      const hasReviews = this.querySelector('.yotpo-review')

      if (hasReviews) {
        this.reveal()
        observer.disconnect()
      }
    })

    observer.observe(this, {
      childList: true,
      subtree: true,
    })
  }

  reveal() {
    this.classList.remove('hidden')

    const stickyPdpNav = document.querySelector('[data-pdp-sticky-nav]')
    const stickyNavItems = stickyPdpNav?.querySelectorAll('[data-link-url]') ?? []
    stickyNavItems.forEach(item => {
      const itemLinkURL = item.dataset?.linkUrl ?? ''
      if (itemLinkURL.includes('product-yotpo-reviews') && item.classList.contains('hidden')) {
        item.classList.remove('hidden')
      }
    })
  }
}

customElements.define('product-yotpo-reviews', ProductYotpoReviews)
